import React from 'react';
import { onScroll } from '@/hooks/paging';
import { presentationOptions } from '@/constants/states';
import CardsHeader from '@/components/cards/CardsHeader';
import { states } from '@/constants/lifecycle';
import ThemesFilters from './ThemesFilters';
import ThemeCards from './ThemeCards';
import ThemesPanelContainer from './ThemesPanelContainer';
import ThemesTable from './ThemesTable';
import selectors from '../hooks/selectors';
import events from '../hooks/events';

const ThemesPanelFull = ({ category, displayAs }) => {
  const state = selectors.useThemesPanel({ category, displayAs });
  const fetchData = events.useFetchThemes(category);
  const togglePresentation = events.useToggleThemesPresentation(category);

  return (
    <ThemesPanelContainer category={category} className="aridhia-themes-panel-full">
      {state.display === presentationOptions.CARDS && (
        <>
          <CardsHeader
            disabled={state.readStatus === states.PENDING}
            onClick={() => togglePresentation({ display: presentationOptions.TABLE })}
          >
            <ThemesFilters category={category} className="aridhia-list-filter" />
          </CardsHeader>
          <ThemeCards
            category={category}
            handleScroll={() => onScroll(fetchData, state)}
            items={state.themes}
            readErrors={state.readErrors}
            readStatus={state.readStatus}
          />
        </>
      )}
      {state.display !== presentationOptions.CARDS && (
      <ThemesTable
        category={category}
        currentPage={state.currentPage}
        fetchData={fetchData}
        pageCount={state.pageCount}
        pageSize={state.pageSize}
        readErrors={state.readErrors}
        readStatus={state.readStatus}
        themes={state.themes}
        togglePresentation={togglePresentation}
        total={state.total}
      />
      )}
    </ThemesPanelContainer>
  );
};

export default ThemesPanelFull;
